export default __webpack_public_path__ + "static/media/tete77.d59d2ca8.png";